import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.loadContent = this.loadContent.bind(this);
    this.element.addEventListener("click", this.loadContent);
  }

  disconnect() {
    this.element.removeEventListener("click", this.loadContent);
  }

  loadContent(event) {
    event.preventDefault();
    turbo_modal.showModal()

    const turboFrameId = "turbo-modal-frame";
    const turboFrame = document.getElementById(turboFrameId);
    if (turboFrame) {
      turboFrame.src = this.element.getAttribute("href");
    }
  }
}